export const updates = [
  { id: 1, date: '2026-07-31', title: '《星际迷航：新纪元》今日全网首播 4K修复版独家上线', tag: '首播', tagColor: 'accent' },
  { id: 2, date: '2026-07-30', title: '《长安十二时辰》导演剪辑版上线 新增30分钟未曝光精彩片段', tag: '独家', tagColor: 'primary' },
  { id: 3, date: '2026-07-29', title: '暑期观影指南发布：7月必看大片推荐清单已全面更新', tag: '指南', tagColor: 'secondary' },
  { id: 4, date: '2026-07-28', title: '《流浪地球3》首支预告片正式发布 定档2027年春节大年初一', tag: '预告', tagColor: 'accent' },
  { id: 5, date: '2026-07-27', title: '经典港片修复计划启动 《无间道》《英雄本色》4K重制进行中', tag: '经典', tagColor: 'primary' },
  { id: 6, date: '2026-07-26', title: '2026年奥斯卡最佳外语片提名作品全收录 现已开放观看', tag: '合集', tagColor: 'secondary' },
  { id: 7, date: '2026-07-25', title: '《封神第二部》特效升级版上线 视听体验全面进化', tag: '升级', tagColor: 'accent' },
  { id: 8, date: '2026-07-24', title: '日韩剧场频道新增50部热门动漫 中日双语字幕同步上线', tag: '上新', tagColor: 'primary' },
  { id: 9, date: '2026-07-23', title: '服务器全面升级完成 4K超清视频加载速度提升300%', tag: '公告', tagColor: 'secondary' },
];

export const contactInfo = {
  title: '投稿与咨询',
  description: '欢迎影迷朋友投稿影评、推荐好片或咨询观影问题。我们的编辑团队将在24小时内回复您的来信。',
  email: 'contact@6080dy.com',
  qq: '608088888',
  wechat: 'movie6080',
};

export const cards = [
  {
    id: 1, title: '星际穿越2：新世界', tag: '科幻巨制', rating: 9.2,
    desc: '克里斯托弗·诺兰监制，视觉奇观再升级，探索未知宇宙的终极奥秘。',
    image: 'https://readdy.ai/api/search-image?query=science%20fiction%20abstract%20cinema%20poster%20deep%20space%20geometric%20planets%20warm%20coral%20and%20navy%20tones%20soft%20glow%20effects%20minimalist%20composition%20no%20text%20cinematic%20atmosphere&width=800&height=560&seq=card-sci-fi-01&orientation=landscape',
  },
  {
    id: 2, title: '长安诡事录', tag: '古装悬疑', rating: 8.9,
    desc: '票房冠军力作，层层反转烧脑不停，带你领略盛唐之下的暗流涌动。',
    image: 'https://readdy.ai/api/search-image?query=historical%20period%20drama%20abstract%20cinema%20poster%20traditional%20Chinese%20architectural%20silhouettes%20warm%20amber%20light%20soft%20ink%20wash%20textures%20elegant%20minimalist%20composition%20no%20text&width=800&height=560&seq=card-period-02&orientation=landscape',
  },
  {
    id: 3, title: '深海危机', tag: '灾难大片', rating: 8.7,
    desc: '视觉震撼的深海冒险，IMAX级特效呈现，每一帧都让人屏住呼吸。',
    image: 'https://readdy.ai/api/search-image?query=disaster%20thriller%20abstract%20cinema%20poster%20dramatic%20ocean%20waves%20warm%20sunset%20lighting%20coral%20and%20amber%20tones%20minimalist%20composition%20no%20text%20cinematic&width=800&height=560&seq=card-disaster-03&orientation=landscape',
  },
  {
    id: 4, title: '回到那一天', tag: '温情喜剧', rating: 8.5,
    desc: '笑中带泪的治愈故事，平凡人生中的不凡温暖，看完心里暖暖的。',
    image: 'https://readdy.ai/api/search-image?query=heartwarming%20comedy%20abstract%20cinema%20poster%20soft%20pastel%20warm%20tones%20organic%20joyful%20shapes%20minimalist%20composition%20no%20text%20cinematic%20atmosphere&width=800&height=560&seq=card-comedy-04&orientation=landscape',
  },
  {
    id: 5, title: '暗影追踪', tag: '动作谍战', rating: 8.8,
    desc: '全程高能的特工对决，拳拳到肉的真实打斗，肾上腺素飙升的视听盛宴。',
    image: 'https://readdy.ai/api/search-image?query=action%20spy%20thriller%20abstract%20cinema%20poster%20dramatic%20urban%20night%20silhouettes%20warm%20amber%20deep%20red%20tones%20sharp%20geometric%20design%20minimalist%20no%20text&width=800&height=560&seq=card-action-05&orientation=landscape',
  },
  {
    id: 6, title: '山河之恋', tag: '文艺爱情', rating: 8.6,
    desc: '多项电影节获奖作品，跨越山海的深情故事，唯美画面如诗如画。',
    image: 'https://readdy.ai/api/search-image?query=romantic%20drama%20abstract%20cinema%20poster%20soft%20warm%20golden%20hour%20lighting%20flowing%20abstract%20shapes%20elegant%20minimalist%20composition%20no%20text%20cinematic&width=800&height=560&seq=card-romance-06&orientation=landscape',
  },
];

export const faqs = [
  {
    id: 1,
    q: '6080电影网需要注册才能观看吗？',
    a: '完全不需要。所有影片均为免费在线观看，无需注册、无需登录、无需任何费用，打开即看。',
  },
  {
    id: 2,
    q: '影片画质怎么样？会不会经常缓冲？',
    a: '我们提供最高4K超清画质，并搭载智能带宽自适应技术，根据您的网络状况自动匹配最佳清晰度，确保流畅播放不缓冲。',
  },
  {
    id: 3,
    q: '新电影多久能上线更新？',
    a: '院线下映后最快7天内上线，热门新片实时跟进。每日更新10部以上影片，确保片库始终新鲜。',
  },
  {
    id: 4,
    q: '手机和平板可以观看吗？画质会变差吗？',
    a: '完美支持手机、平板、电脑全平台播放。移动端有专属优化，在保证画质的同时大幅节省流量，通勤路上也能畅享高清大片。',
  },
];

export const carouselItems = [
  {
    id: 1,
    title: '暑期档盛宴',
    subtitle: '炎炎夏日 · 在家看大片',
    desc: '精选暑期热门新片，从科幻巨制到温情喜剧，足不出户享受影院级视听体验。',
    image: 'https://readdy.ai/api/search-image?query=wide%20cinematic%20landscape%20summer%20movie%20marathon%20cozy%20home%20theater%20warm%20golden%20sunlight%20soft%20coral%20amber%20tones%20abstract%20floating%20elements%20no%20text%20editorial%20design&width=900&height=400&seq=carousel-summer-01&orientation=landscape',
  },
  {
    id: 2,
    title: '经典重温',
    subtitle: '那些年我们追过的电影',
    desc: '从《大话西游》到《无间道》，经典永不褪色，每一遍都有新的感动。',
    image: 'https://readdy.ai/api/search-image?query=wide%20cinematic%20vintage%20nostalgia%20classic%20films%20film%20projector%20warm%20light%20floating%20abstract%20frames%20sepia%20amber%20tones%20elegant%20composition%20no%20text&width=900&height=400&seq=carousel-classic-02&orientation=landscape',
  },
  {
    id: 3,
    title: '科幻宇宙',
    subtitle: '探索未知的无限可能',
    desc: '从《流浪地球》到《星际穿越》，硬核科幻迷的天堂，每一部都值得反复品味。',
    image: 'https://readdy.ai/api/search-image?query=wide%20cosmic%20sci-fi%20universe%20abstract%20nebula%20colors%20floating%20geometric%20shapes%20planet%20stars%20deep%20coral%20gold%20tones%20editorial%20design%20no%20text&width=900&height=400&seq=carousel-scifi-03&orientation=landscape',
  },
  {
    id: 4,
    title: '华语力量',
    subtitle: '国产电影的崛起之路',
    desc: '见证中国电影的黄金时代，从票房奇迹到国际获奖，华语电影正在闪耀世界。',
    image: 'https://readdy.ai/api/search-image?query=wide%20Chinese%20cinema%20celebration%20abstract%20brush%20stroke%20textures%20warm%20red%20gold%20flowing%20elegant%20composition%20film%20storytelling%20traditional%20modern%20aesthetic%20no%20text&width=900&height=400&seq=carousel-chinese-04&orientation=landscape',
  },
];

export const rankings = [
  { id: 1, rank: 1, title: '星际穿越2：新世界', tag: '科幻', views: '999万', hot: true },
  { id: 2, rank: 2, title: '长安诡事录', tag: '悬疑', views: '856万', hot: true },
  { id: 3, rank: 3, title: '深海危机', tag: '灾难', views: '742万', hot: true },
  { id: 4, rank: 4, title: '暗影追踪', tag: '动作', views: '688万', hot: false },
  { id: 5, rank: 5, title: '回到那一天', tag: '喜剧', views: '521万', hot: false },
  { id: 6, rank: 6, title: '山河之恋', tag: '爱情', views: '489万', hot: false },
];

export const appInfo = {
  title: '随时随地 · 畅享大片',
  description: '6080电影网移动端已全面优化，手机浏览器打开即可观看。支持投屏到电视，小屏变大屏，观影更尽兴。',
  features: ['免安装即开即看', '流量优化省带宽', '一键投屏到电视', '夜间模式护眼'],
};

export const topics = [
  { id: 1, name: '科幻大片', count: 328, icon: 'ri-rocket-line' },
  { id: 2, name: '悬疑推理', count: 256, icon: 'ri-search-eye-line' },
  { id: 3, name: '动作冒险', count: 412, icon: 'ri-flashlight-line' },
  { id: 4, name: '喜剧搞笑', count: 189, icon: 'ri-emotion-laugh-line' },
  { id: 5, name: '爱情文艺', count: 167, icon: 'ri-heart-line' },
  { id: 6, name: '恐怖惊悚', count: 143, icon: 'ri-ghost-line' },
  { id: 7, name: '动画动漫', count: 275, icon: 'ri-movie-line' },
  { id: 8, name: '纪录纪实', count: 98, icon: 'ri-camera-line' },
  { id: 9, name: '经典老片', count: 201, icon: 'ri-film-line' },
];

export const features = [
  {
    id: 1,
    icon: 'ri-speed-up-line',
    title: '秒开无广告',
    desc: '极速加载技术，点开即播无需等待。纯净观影体验，全程零广告打扰，沉浸式享受每一部电影。',
  },
  {
    id: 2,
    icon: 'ri-4k-line',
    title: '高清不缓冲',
    desc: '智能CDN全球加速节点，4K超清画质搭配自适应码率技术，无论网络环境如何都能流畅播放。',
  },
  {
    id: 3,
    icon: 'ri-database-2-line',
    title: '海量片库',
    desc: '收录超过20000部影片，覆盖科幻、悬疑、动作、喜剧、爱情等全类型，每日持续更新10部以上。',
  },
];

export const mediaItems = [
  {
    id: 1,
    title: '《星际穿越2》震撼片段',
    desc: '黑洞穿越场景首次曝光',
    duration: '03:25',
    image: 'https://readdy.ai/api/search-image?query=sci-fi%20spaceship%20interior%20warm%20dramatic%20lighting%20abstract%20geometric%20composition%20cinematic%20color%20grading%20amber%20tones%20no%20text%20thumbnail&width=800&height=500&seq=media-scifi-01&orientation=landscape',
  },
  {
    id: 2,
    title: '《长安诡事录》幕后花絮',
    desc: '导演揭秘悬疑场景拍摄',
    duration: '05:12',
    image: 'https://readdy.ai/api/search-image?query=behind%20the%20scenes%20film%20studio%20warm%20lighting%20abstract%20filming%20equipment%20silhouettes%20soft%20coral%20tones%20editorial%20photography%20no%20text%20thumbnail&width=800&height=500&seq=media-bts-02&orientation=landscape',
  },
  {
    id: 3,
    title: '《深海危机》特效解析',
    desc: '揭秘IMAX级视觉奇观',
    duration: '04:48',
    image: 'https://readdy.ai/api/search-image?query=visual%20effects%20showcase%20abstract%20particle%20effects%20warm%20golden%20coral%20tones%20cinematic%20lighting%20minimalist%20composition%20no%20text%20thumbnail&width=800&height=500&seq=media-vfx-03&orientation=landscape',
  },
  {
    id: 4,
    title: '《暗影追踪》动作集锦',
    desc: '五分钟高燃打斗混剪',
    duration: '05:00',
    image: 'https://readdy.ai/api/search-image?query=action%20sequence%20abstract%20dramatic%20motion%20lines%20warm%20amber%20lighting%20dynamic%20geometric%20composition%20editorial%20style%20no%20text%20thumbnail&width=800&height=500&seq=media-action-04&orientation=landscape',
  },
];

export const about = {
  title: '关于6080电影网',
  paragraphs: [
    '6080电影网是国内领先的免费在线观影平台，自成立以来始终秉持"高清不缓冲、秒开无广告"的服务理念，为数千万影迷提供最新电影在线观看服务。我们汇聚了最新上映影片、经典电影佳作、热门剧集等海量高清内容。',
    '平台每日更新超过10部最新电影，覆盖科幻、悬疑、动作、喜剧、爱情、恐怖、动画、纪录片等全类型题材。无论你喜欢好莱坞大片还是国产佳作，在这里都能找到心头好。',
    '我们采用全球智能CDN加速与自适应码率技术，确保每一位用户都能在不同网络环境下获得流畅的高清观影体验。6080电影网，让看电影变得更简单、更纯粹。',
  ],
};

export const comments = [
  {
    id: 1,
    name: '影迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20man%20portrait%20warm%20lighting%20friendly%20smile%20casual%20style%20simple%20background%20professional%20headshot&width=80&height=80&seq=avatar-wang-01&orientation=squarish',
    date: '2026-07-30',
    content: '用了快两年了，片源更新真的快！昨天影院刚下线的片子今天就看到了，画质也很棒，推荐给身边所有朋友了。',
    rating: 5,
  },
  {
    id: 2,
    name: '电影发烧友阿杰',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Asian%20man%20portrait%20with%20glasses%20warm%20tone%20intellectual%20look%20simple%20clean%20background%20professional%20headshot&width=80&height=80&seq=avatar-jie-02&orientation=squarish',
    date: '2026-07-28',
    content: '作为一个看了上千部电影的老影迷，6080的分类和推荐真的用心。小众文艺片也能找到，片库深度没得说。',
    rating: 5,
  },
  {
    id: 3,
    name: '追剧少女小美',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Chinese%20woman%20portrait%20warm%20natural%20lighting%20gentle%20smile%20simple%20soft%20background%20professional%20headshot&width=80&height=80&seq=avatar-mei-03&orientation=squarish',
    date: '2026-07-26',
    content: '手机上看超方便！通勤路上就能追完一部电影，流量也用得不多。最惊喜的是真的没有广告，体验感满分。',
    rating: 5,
  },
  {
    id: 4,
    name: '科技宅老张',
    avatar: 'https://readdy.ai/api/search-image?query=middle%20aged%20Chinese%20man%20portrait%20warm%20tone%20confident%20expression%20simple%20clean%20background%20professional%20headshot&width=80&height=80&seq=avatar-zhang-04&orientation=squarish',
    date: '2026-07-25',
    content: '做技术出身的，对画质要求比较高。6080的4K画质确实没让我失望，码率够高，投屏到75寸电视上看效果依然很赞。',
    rating: 4,
  },
  {
    id: 5,
    name: '周末影咖阿琳',
    avatar: 'https://readdy.ai/api/search-image?query=young%20Asian%20woman%20portrait%20warm%20natural%20lighting%20bright%20smile%20simple%20soft%20background%20professional%20headshot&width=80&height=80&seq=avatar-lin-05&orientation=squarish',
    date: '2026-07-23',
    content: '每个周末都会打开6080找片子看，最近的暑期档专题做得太好了，一口气把想看的都看完了。免费无广告真的太香了！',
    rating: 5,
  },
];

export const indexItems = [
  {
    id: 1,
    title: '暑期档热映',
    icon: 'ri-sun-line',
    desc: '炎炎夏日，在家看大片。精选暑期热门新片合集，一次看过瘾。',
    count: 48,
  },
  {
    id: 2,
    title: '豆瓣高分',
    icon: 'ri-star-line',
    desc: '8.0分以上的口碑佳作，每一部都经得起时间考验的经典好片。',
    count: 156,
  },
  {
    id: 3,
    title: '好莱坞巨制',
    icon: 'ri-global-line',
    desc: '最新好莱坞商业大片和独立佳作，原声中字体验原汁原味。',
    count: 234,
  },
  {
    id: 4,
    title: '国漫崛起',
    icon: 'ri-china-railway-line',
    desc: '从《哪吒》到《长安三万里》，见证国产动画的华丽蜕变。',
    count: 67,
  },
  {
    id: 5,
    title: '日韩精选',
    icon: 'ri-earth-line',
    desc: '日韩热门影视剧和动漫，悬疑、爱情、治愈全覆盖。',
    count: 189,
  },
  {
    id: 6,
    title: '午夜惊魂',
    icon: 'ri-moon-line',
    desc: '恐怖惊悚片爱好者聚集地，从日式心理恐怖到好莱坞视觉恐怖。',
    count: 82,
  },
  {
    id: 7,
    title: '获奖佳作',
    icon: 'ri-award-line',
    desc: '奥斯卡、戛纳、柏林等国际电影节获奖作品全收录。',
    count: 93,
  },
];

export const navLinks = [
  { label: '热门推荐', href: '#cards' },
  { label: '热度榜单', href: '#ranking' },
  { label: '精彩预告', href: '#media' },
  { label: '特色优势', href: '#features' },
  { label: '移动观影', href: '#app' },
  { label: '联系我们', href: '#contact' },
];